const names = {
    ChangedToSurveyList: "ROUTECHANGE.CHANGEDTOSURVEYLIST",
    ChangedToSurvey: "ROUTECHANGE.CHANGEDTOSURVEY",
    ChangedToSurveyConfirmation: "ROUTECHANGE.CHANGEDTOSURVEYCONFIRMATION", 
    ChangedToSurveySummary: "ROUTECHANGE.CHANGEDTOSURVEYSUMMARY",
    ChangedToLegacySurvey: "ROUTECHANGE.CHANGEDTOLEGACYSURVEY",
    ChangedToSurveyNotFound: "ROUTECHANGE.CHANGEDTOSURVEYNOTFOUND",
    ChangedToImpersonation: "ROUTECHANGE.CHANGEDTOIMPERSONATION",
    ChangedToReports: "ROUTECHANGE.CHANGEDTOREPORTS",
    ChangedToWalkThru: "ROUTECHANGE.CHANGEDTOWALKTHRU"
};

const routeChangeEvents = {
    ChangedToSurveyList: {
        Name: names.ChangedToSurveyList,
        New(searchParameters) {
            return {
                type: names.ChangedToSurveyList,
                SearchParameters: searchParameters
            };
        }
    },
    ChangedToSurvey: {
        Name: names.ChangedToSurvey,
        New(surveyType, facNumber, surveyID, pageID, sectionID) {
            if (!surveyType) {
                throw "No survey type was specified.";
            }

            if (!surveyID) {
                throw "No survey ID was specified.";
            }

            return {
                type: names.ChangedToSurvey,
                SurveyType: surveyType,
                FacilityNumber: facNumber,
                SurveyID: surveyID,
                PageID: pageID,
                SectionID: sectionID
            };
        }
    },
    ChangedToSurveyConfirmation: {
        Name: names.ChangedToSurveyConfirmation,
        New(surveyType, facNumber, surveyID) {
            if (!surveyType) {
                throw "No survey type was specified.";
            }

            if (!surveyID) {
                throw "No survey ID was specified."; 
            }

            return {
                type: names.ChangedToSurveyConfirmation,
                SurveyType: surveyType,
                FacilityNumber: facNumber,
                SurveyID: surveyID
            }
        }
    }, 
    ChangedToSurveySummary: {
        Name: names.ChangedToSurveySummary,
        New(surveyType, facNumber, surveyID) {
            if (!surveyType) {
                throw "No survey type was specified.";
            }

            if (!surveyID) {
                throw "No survey ID was specified.";
            }

            return {
                type: names.ChangedToSurveySummary,
                SurveyType: surveyType,
                FacilityNumber: facNumber,
                SurveyID: surveyID
            };
        }
    },
    ChangedToLegacySurvey: {
        Name: names.ChangedToLegacySurvey,
        New(surveyType, facNumber, surveyID) {
            if (!surveyType) {
                throw "No survey type was specified.";
            }

            if (!surveyID) {
                throw "No survey ID was specified.";
            }

            return {
                type: names.ChangedToLegacySurvey,
                SurveyType: surveyType,
                FacilityNumber: facNumber,
                SurveyID: surveyID
            };
        }
    },
    ChangedToImpersonation: {
        Name: names.ChangedToImpersonation,
        New() {
            return {
                type: names.ChangedToImpersonation
            };
        }
    },
    ChangedToReports: {
        Name: names.ChangedToReports,
        New() {
            return {
                type: names.ChangedToReports
            };
        }
    },
    ChangedToWalkThru: {
        Name: names.ChangedToWalkThru,
        New(surveyType, facNumber, surveyID) {
            if (!surveyType) {
                throw "No survey type was specified.";
            }

            if (!surveyID) {
                throw "No survey ID was specified.";
            }

            return {
                type: names.ChangedToWalkThru,
                SurveyType: surveyType,
                FacilityNumber: facNumber,
                SurveyID: surveyID
            };
        }
    },
};

module.exports = routeChangeEvents;


// WEBPACK FOOTER //
// ./src/events/routeChange/routeChangeEvents.js